import { createContext } from 'react';

const ApiUrlContext = createContext();

export default ApiUrlContext;